import { onBeforeUnmount, type Ref, watch } from 'vue';

let lockCount = 0;

const lockScroll = () => {
  lockCount++;
  if (lockCount === 1) document.body.style.overflow = 'hidden';
};

const unlockScroll = () => {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) document.body.style.overflow = '';
};

export const useScrollLock = (isOpen: Ref<boolean>) => {
  watch(
    isOpen,
    (open, wasOpen) => {
      if (open) lockScroll();
      else if (wasOpen !== undefined) unlockScroll();
    },
    { immediate: true },
  );

  onBeforeUnmount(() => {
    if (isOpen.value) unlockScroll();
  });
};
